import {useState} from "react";
import {useAuth} from "@/hooks/useAuth";
import {passPng, logoPng} from "@chayka/assets";
import {BottomSheet} from "../layout";
import {ShadowBox, XStack, YStack} from "@chayka/ui";

export const Pass = () => {
  const {user} = useAuth();

  const [isOpen, setIsOpen] = useState(false);

  if (user?.confirmationStatus !== "approved") {
    return null;
  }

  return (
    <>
      <div
        className="w-full h-11 overflow-hidden rounded-xl relative"
        onClick={() => setIsOpen(true)}
      >
        <img
          className="absolute top-0 left-0 w-full h-full object-cover"
          src={passPng}
          alt="Пропуск"
        />
        <div className="w-full h-full bg-blackout opacity-50 absolute top-0 left-0"></div>
        <p className="absolute font-bold text-sm top-1/2 left-4 transform -translate-y-1/2 text-white">
          Мой пропуск
        </p>
      </div>
      <BottomSheet fullHeight isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className="w-full h-full absolute left-0 top-0 flex flex-col items-center justify-start gap-4 p-6 bg-gray-300">
          <ShadowBox className="flex flex-col w-full overflow-hidden rounded-xl bg-background items-center p-6 gap-6">
            <img className="w-50 py-6" src={logoPng} alt="Чайка" />
            <h1 className="text-3xl font-bold">ПРОПУСК</h1>
            <img className="w-full h-2/5 object-cover rounded-xl" src={passPng} alt="Пропуск" />

            <YStack className="self-stretch gap-2">
              <XStack className="w-full justify-between gap-2">
                <span className="font-bold">ФИО</span>
                <span>
                  {user?.firstName} {user?.lastName}
                </span>
              </XStack>
              <XStack className="w-full justify-between gap-2">
                <span className="font-bold">Категория</span>
                <span className="text-end">{user?.userType}</span>
              </XStack>
            </YStack>
          </ShadowBox>
        </div>
      </BottomSheet>
    </>
  );
};
